<template>
  <div class="control is-vertical">
    <div class="control is-grouped">
      <p class="control is-expanded">
        <label class="label">Confirmation Number</label>
        <input :class="{'input': true, 'is-danger': errors.has('confirmation')}" name="confirmation" id="confirmation" type="text" placeholder="Confirmation" v-model="reconfirm.confirmation" v-validate data-vv-rules="required">
        <span v-show="errors.has('confirmation')" class="help is-danger">{{ errors.first('confirmation') }}</span>
      </p>
      <p class="control is-expanded">
        <label class="label">Attendant Name</label>
        <input :class="{'input': true, 'is-danger': errors.has('attendant')}" name="attendant" id="attendant" type="text" placeholder="Attendant" v-model="reconfirm.attendant" v-validate data-vv-rules="required">
        <span v-show="errors.has('attendant')" class="help is-danger">{{ errors.first('attendant') }}</span>
      </p>
      <p class="control is-expanded">
        <label class="label">Payment Status</label>
        <select class="select is-fullwidth" v-model="reconfirm.payment" name="payment" id="payment">
          <option v-bind:value="1">Payed</option>
          <option v-bind:value="2">Not Payed</option>
        </select>
      </p>
      <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any()}" style="margin-top: 20px;" @click="reconfirmService">Reconfirm</a>
    </div>
  </div>
</template>

<script>
  import message from '../../utils/message'
  export default {
    props: {
      service: {
        type: Object
      }
    },
    data () {
      return {
        reconfirm: {
          service_id: '',
          attendant: '',
          confirmation: '',
          payment: 1
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.reconfirm.service_id = this.service.id
      })
    },
    methods: {
      reconfirmService () {
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.$http.post(this.$store.state.config.apiURL + '/services/reconfirm', this.reconfirm).then((response) => {
              window.location.reload()
              this.message('success', 'Success', 'The service was successfully reconfirmed')
            }, (response) => {
              this.message('danger', 'Error', response.body)
            })
          }
        })
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Reconfirm.vue?0f73b6ca